import React from 'react'
import { PreviewLayout } from '../sub-components/PreviewLayout'
import { PreviewBody } from '../sub-components/PreviewLayout'
import LoadingList from '../skeletons/LoadingList'
import LoadingDiscountList from '../skeletons/LoadingDiscountList'
import { CouponsPageType } from 'src/lib/types/uiPreview'

const CouponsPage: React.FC<CouponsPageType> = ({ colorPalette }) => {
  return (
    <PreviewLayout hideLogo>
      <>
        <PreviewBody>
          <LoadingList
            length={1}
            skeleton={{
              layout: 'row',
              config: [
                { height: 1, width: 1 },
                { height: 1, width: 6 }
              ]
            }}
          />
          <LoadingDiscountList
            primaryColor={colorPalette.primaryColor}
            primaryTextColor={colorPalette.primaryTextColor}
            length={2}
            skeleton={{
              layout: 'column',
              config: [
                {
                  layout: 'row',
                  config: [
                    {
                      height: 1,
                      width: 1
                    },
                    {
                      height: 1,
                      width: 8
                    }
                  ]
                },
                { height: 1, width: 4 },
                { height: 1, width: 10 },
                { height: 1, width: 3 }
              ]
            }}
          />
        </PreviewBody>
      </>
    </PreviewLayout>
  )
}

export default CouponsPage
